import { createSlice } from "@reduxjs/toolkit";
import { LostStrandType } from "../../models/caster.models";

const CatalogLostStrandTypesInitialState: {
	lostStrandTypes: LostStrandType[] | null;
} = {
	lostStrandTypes: null,
};

export const CatalogLostStrandTypesReducer = createSlice({
	name: "__",
	initialState: CatalogLostStrandTypesInitialState,
	reducers: {
		setLostStrandTypes(state, { payload }) {
			state.lostStrandTypes = payload;
		},
	},
});
